import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { RedirectListParams } from '../api/redirects-api';
import { REDIRECT_FILTER_FIELDS, REDIRECT_SORTS } from '../components/redirect-filters';

/** URL search params of the redirects list; `q` matches either path. */
export const redirectListSearchSchema = indexSearchSchema(REDIRECT_FILTER_FIELDS, {
  sort: REDIRECT_SORTS,
});

export type RedirectListSearch = z.infer<typeof redirectListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function redirectListParams(search: RedirectListSearch): RedirectListParams {
  return listParams(search, REDIRECT_FILTER_FIELDS);
}
